<template>
  <md-card>
    <md-card-content v-for="(invoice, index) in value" :key="index" class="invoice-card">
      <h5>
        <strong>{{ invoice.uuid }}</strong>
      </h5>
      <div style="width: 100%;">
        <md-chip :class="{'md-success': invoice.PDF}">
          <div class="chip-content" v-if="invoice.PDF">
            <md-icon class="chip-icon">{{ fileIcon(invoice.PDF.name).icon }}</md-icon>
            <p>
              <strong>Archivo PDF</strong>
            </p>
            <md-button
              v-if="!invoice.id"
              class="md-just-icon md-danger md-round"
              @click.native="$emit('removeFile', invoice.PDF)"
            >
              <md-icon>delete</md-icon>
            </md-button>
            <md-button
              v-else
              class="md-just-icon md-info md-round"
              @click.native="seeFile(invoice.PDF)"
            >
              <md-icon>visibility</md-icon>
            </md-button>
          </div>
          <div class="chip-content" v-else>
            <p>
              <strong>Falta PDF</strong>
            </p>
          </div>
        </md-chip>
        <md-chip :class="{'md-success': invoice.XML}">
          <div class="chip-content" v-if="invoice.XML">
            <md-icon class="chip-icon">{{ fileIcon(invoice.XML.name).icon }}</md-icon>
            <p>
              <strong>Archivo XML</strong>
            </p>
            <md-button
              v-if="!invoice.id"
              class="md-just-icon md-danger md-round float-right"
              @click.native="$emit('removeFile', invoice.XML)"
            >
              <md-icon>delete</md-icon>
            </md-button>
            <md-button
              v-else
              class="md-just-icon md-info md-round"
              @click.native="seeFile(invoice.XML)"
            >
              <md-icon>visibility</md-icon>
            </md-button>
          </div>
          <div class="chip-content" v-else>
            <p>
              <strong>Falta XML</strong>
            </p>
          </div>
        </md-chip>
      </div>
      <div>
        <md-button
          v-if="!invoice.id"
          class="md-just-icon md-primary md-round"
          @click.native="$emit('removeInvoice', invoice)"
        >
          <md-icon>close</md-icon>
        </md-button>
        <md-button
          v-if="invoice.id && $can('delete', 'PurchaseRequisition', 'buyordertaxreceipt')"
          class="md-just-icon md-primary md-round"
          @click.native="$emit('deleteInvoice', invoice, index)"
        >
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { taxReceiptStatus } from "@/pages/TaxReceipt/utils";
import { fileIcon, isImageURL } from "@/utils";
import urlUtility from "@/utils/assetURL";

export default {
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  filters: {
    taxReceiptStatus,
  },
  data() {
    return {
      fileIcon,
    };
  },
  computed: {},
  methods: {
    seeFile(file) {
      const cFile = urlUtility(file);
      if (!isImageURL(file)) {
        const win = window.open(cFile, "_blank");
        win.focus();
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.md-card-content {
  display: flex;
  justify-content: space-between;
  align-content: center;
  h5 {
    margin-right: 8px;
    width: 20%;
  }
  .md-chip {
    margin: 0;
    padding: 4px 12px;
    margin-right: 12px;
    min-width: 340px;
    height: auto;
    align-content: center;
    text-align: center;
    .chip-content {
      font-size: 16px;
      width: 100%;
      display: flex;
      max-height: 90%;
      justify-content: space-around;
      p {
        margin: auto;
        height: 24px;
        vertical-align: middle;
      }
    }
    .chip-icon {
      margin: 0;
    }
  }

  .delete-invoice-button {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/invoiceManager.vue